import React, { useState, useEffect } from 'react'
import SpinnerLoading from 'components/Loading/SpinnerLoading'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../redux/actions'
import BackButton from 'components/Button/BackButton'
import { useParams, Link } from 'react-router-dom'
//import { Link } from 'react-router-dom'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { stationAll } from '../../redux/actions'
import dayjs from 'dayjs'
import {
  Button,
  ButtonGroup,
  Table,
  Thead,
  Tr,
  Th,
  Td,
  Tbody,
} from '@chakra-ui/react'

export default function ElectricBillYears() {
  const { t } = useTranslation()
  const [allowedDashboard, setAllowedDashboard] = useState()
  const me = useSelector((state) => state.me)
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const electricConsumption = useSelector((state) => state.electricConsumption)
  // console.log('Electric consumtion ------ปปปปป-------', electricConsumption)
  const stations = useSelector((state) => state.station)
  const params = useParams()
  // console.log('Params ', params)

  useEffect(() => {
    dispatch(actions.stationAll()).then(() => setIsLoading(true))
    return () => {}
  }, [])

  useEffect(() => {
    dispatch(actions.electricConsumptionAll()).then(() => {
      dispatch(actions.systemInfoGet()).then(() => {
        setIsLoading(true)
      })
    })

    return () => {}
  }, [])

  useEffect(() => {
    dispatch(stationAll()).then(() => {
      setIsLoading(true)
    })
    return () => {}
  }, [])

  // ตรวจสอบว่า User ที่เข้ามามี Permission ที่เข้าสถานีไหนได้บ้าง
  // ตอนนี้ยังเก็บเป็น Text อยู่ เก็บเฉพาะใน User ไม่ได้เก็บในสถานี
  // ถ้าอนุญาติหมดจะเป็น ALLAREA
  // TODO: ถ้าเป็น Array จะดีมาก
  useEffect(() => {
    if (me && me._id) {
      if (_.size(stations.arr)) {
        if (_.includes(me.duty, 'ALLAREA')) {
          const allowedStationStack = stations.arr
          setAllowedDashboard(allowedStationStack)
        } else {
          const allowedStation = _.filter(
            stations.arr,
            (station, index) => station._id === me.duty[index]
          )
          setAllowedDashboard(allowedStation)
        }
      }
    }
    return () => {}
  }, [stations, me])

  const calYearData = () => {
    const yearSummary = _.filter(
      electricConsumption?.arr,
      (station) => station.stationId === params.id
    )
    const year24 = []
    const year23 = []
    _.map(yearSummary, (ys, id) => {
      if (
        dayjs(yearSummary[id]?.date).format('YYYY') ===
        dayjs(new Date()).format('YYYY')
      ) {
        year24.push(ys)
      } else {
        year23.push(ys)
      }
    })
    const totalYear = []

    totalYear.push(year24, year23)
    // console.log(
    //   'year',
    //   year24,
    //   year23,
    //   totalYear[0],
    //   _.sumBy(year23, (o) => {
    //     return o?.all
    //   })
    // )
    return totalYear
  }

  const genBodyLists = () =>
    // ดึงค่าไฟแต่ละเดือน เฉพาะ station ที่เลือก
    _.map(calYearData(), (data, index) => (
      <Tr key={data.index}>
        <Td> {2024 - index} </Td>
        <Td>
          {Intl.NumberFormat().format(
            _.sumBy(data, (o) => {
              return o?.all
            })
          ) + ' หน่วย'}
        </Td>
        <Td>
          {Intl.NumberFormat().format(
            _.sumBy(data, (o) => {
              return o?.summary
            })
          ) + ' บาท '}
        </Td>
        <Td>
          <Link
            to={
              '/electric-bill-estimator/month/' + `${2024 - index}/` + params.id
            }
          >
            <Button colorScheme="linkedin" variant="solid">
              รายละเอียด
            </Button>
          </Link>
        </Td>
      </Tr>
    ))

  return isLoading ? (
    <div className="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
      <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div className="flex flex-wrap items-center">
          <div className="relative w-full max-w-full flex-grow flex-1">
            <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans">
              {t('electricBill.electricBill')}
            </h6>
            <h2 className="text-gray-800 text-2xl font-bold font-sans">
              ประมาณการบิลค่าไฟฟ้า รายปี
            </h2>
          </div>
        </div>
        <Button>
          <BackButton />
        </Button>
        <div className="p-4 w-full">
          {_.size(electricConsumption?.arr) ? (
            <div className="overflow-x-auto">
              <Table size="sm" variant="striped" className="whitespace-no-wrap">
                <Thead>
                  <Tr>
                    <Th>ปี</Th>
                    <Th>{t('counter.unit')}</Th>
                    <Th>{t('electricBill.electricTotalAddTax')}</Th>
                  </Tr>
                </Thead>
                <Tbody>{genBodyLists()}</Tbody>
              </Table>
            </div>
          ) : (
            <div>{t('utility.empty')}</div>
          )}
        </div>
      </div>
    </div>
  ) : (
    <SpinnerLoading />
  )
}
